export default __webpack_public_path__ + "assets/Card_BorderGreen.webp";